import Modal from '../modal/modal';
import ModalSubscription from '../modal-subscription/modal-subscription';

export default new class ModalPromo {
  constructor() {
    this.openPromoBtn = '.js-promo-modal-open-btn';
    this.modalPromo = '.modal-promo';
    this.PersonalDataPromoContainer = '.personal-data._promo';
    this.modalPromoItem = '.promo-item';

    this.disableClass = '_disable';
    this.init();
  }

  init() {
    if (!('.modal-subscription').length) return;
    this.bindEvents();
  }

  bindEvents() {
    $(document)
      .on('click', this.openPromoBtn, (e) => {
        e.preventDefault();

        const $clickedLink = $(e.currentTarget);
        const targetDataValue = $clickedLink.data('modal-link');

        $.request('UserPromoCode::onGetByTariff', {
          data: {
            tariff_id: ModalSubscription.tariffId,
          },
          update: {
            '/project/common/modal-promo/modal-promo-content': '.modal-promo',
          },
          complete() {
            Modal.openModal($clickedLink, $(`.${Modal.modalContent}[data-modal='${targetDataValue}']`));
          },
        });
      });
  }

  /**
     * Disable/enable promoCode im modal-promo
     */
  togglePromo($promoItemParam, promoCode, setDisable) {
    let $promoItem = $promoItemParam;

    if (!$promoItem) {
      $promoItem = $(this.modalPromo).find(`[data-promo='${promoCode}']`);
    }

    if (setDisable) {
      $promoItem.addClass(this.disableClass);
    } else {
      $promoItem.removeClass(this.disableClass);
    }
  }

  /**
     * Count amount of available promocodes
     *
     * @returns {number|jQuery} - amount of available promocodes
     */
  getPromoAmount() {
    const $container = $(this.PersonalDataPromoContainer).length
      ? $(this.PersonalDataPromoContainer) : $(this.modalPromo);

    return $container.find(`${this.modalPromoItem}:not(._disabled)`).length;
  }
}();
